import {Component} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

import {AuthService} from './shared/services/auth.service';
import {MessagingService} from './shared/services/messaging.service';
import {SocketService} from './shared/services/socket.service';
import {GtmService} from './shared/services/gtm.service';
import {GtmEvent, GtmTag} from './shared/models/gtm.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    public authService: AuthService,
    private socketService: SocketService,
    private messagingService: MessagingService,
    private gtmService: GtmService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.authService.authUser.subscribe((user) => {
      if (user) {
        this.messagingService.requestPermission();
      }
    });
    this.authService.autoLogin();
    this.socketService.initSocket();
    this.trackPageEventsGtm();
  }

  trackPageEventsGtm(): void {
    this.router.events.subscribe(item => {
      if (item instanceof NavigationEnd) {
        const gtmTag: GtmTag = {
          event: GtmEvent.PAGE_VIEW,
          pageName: item.url
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
  }
}
